/** Opens the full All Leads page in a popup iframe from the terminal assistant. */
import { describeSearchFilters, parseAssistantSearchQuery, buildLeadsPageUrl } from './assistant-search.js';

let shell = null;
let els = {};
/** @type {{ onOpenLead?: (id: number) => void }} */
let ctx = {};

function el(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text != null) node.textContent = text;
  return node;
}

function onWindowMessage(event) {
  if (event.origin !== location.origin) return;
  if (event.data?.type !== 'mysky-assistant-open-lead') return;
  const leadId = event.data.leadId;
  if (!leadId) return;
  closeAssistantSearchPopup();
  ctx.onOpenLead?.(leadId);
}

function ensureShell() {
  if (shell) return shell;

  shell = el('div', 'assistant-leads-overlay hidden');
  shell.id = 'assistantLeadsOverlay';
  shell.setAttribute('role', 'dialog');
  shell.setAttribute('aria-modal', 'true');
  shell.setAttribute('aria-labelledby', 'assistantLeadsTitle');

  const modal = el('div', 'assistant-leads-modal');
  const head = el('header', 'assistant-leads-head');
  const titleWrap = el('div', 'assistant-leads-head-text');
  els.title = el('h2', 'assistant-leads-title', 'All leads');
  els.title.id = 'assistantLeadsTitle';
  els.subtitle = el('p', 'assistant-leads-subtitle');
  els.filters = el('p', 'assistant-leads-filters');
  titleWrap.append(els.title, els.subtitle, els.filters);

  const closeBtn = el('button', 'assistant-leads-close', 'Close');
  closeBtn.type = 'button';
  closeBtn.setAttribute('aria-label', 'Close leads browser');
  closeBtn.addEventListener('click', () => closeAssistantSearchPopup());
  head.append(titleWrap, closeBtn);

  els.frame = el('iframe', 'assistant-leads-frame');
  els.frame.title = 'All leads — filter and pick an inquiry';
  els.frame.setAttribute('loading', 'eager');

  modal.append(head, els.frame);
  shell.appendChild(modal);

  shell.addEventListener('click', (e) => {
    if (e.target === shell) closeAssistantSearchPopup();
  });

  document.addEventListener('keydown', onEscape);
  window.addEventListener('message', onWindowMessage);
  document.body.appendChild(shell);
  return shell;
}

function onEscape(e) {
  if (e.key === 'Escape' && shell && !shell.classList.contains('hidden')) {
    closeAssistantSearchPopup();
  }
}

export function initAssistantSearchPopup(config = {}) {
  ctx = { ...ctx, ...config };
  ensureShell();
}

export function isAssistantSearchPopupOpen() {
  return !!(shell && !shell.classList.contains('hidden'));
}

export function closeAssistantSearchPopup() {
  if (!shell) return;
  shell.classList.add('hidden');
  document.body.classList.remove('assistant-leads-open');
  if (els.frame) els.frame.src = 'about:blank';
}

export function openAssistantSearchPopup(rawQuery) {
  ensureShell();
  const query = String(rawQuery || '').trim();
  const parsed = parseAssistantSearchQuery(query);
  const url = buildLeadsPageUrl(query, {
    agentId: ctx.agentId,
    viewAll: ctx.viewAll,
  });

  els.subtitle.textContent = query || 'Browse all leads';
  els.filters.textContent = describeSearchFilters(parsed);
  els.frame.src = url;

  shell.classList.remove('hidden');
  document.body.classList.add('assistant-leads-open');
}
